import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatOptionModule } from '@angular/material/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormField } from '../form-field.component';
import { MatIconButton } from '@angular/material/button';

@Component({
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatIconModule, MatDividerModule, MatOptionModule, TranslatePipe, MatIconButton],
  selector: 'app-form-field-select',
  templateUrl: './form-field-select.component.html',
  styleUrls: ['./form-field-select.component.scss'],
  standalone: true,
})
export class FormFieldSelectComponent extends FormField implements OnChanges {
  @Input()
  choices: unknown[];

  @Input()
  displayFn: (v: unknown) => string;

  @Input()
  valueFn: (v: unknown) => unknown;

  @Input()
  multiple = false;

  @Input()
  displayTriggerRef: TemplateRef<unknown>;

  @Input()
  displayTemplateRef: TemplateRef<unknown>;

  @Output()
  selectionChanged: EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();

  @Input()
  value: any;
  @Output()
  valueChanged = new EventEmitter<any>();

  @Input()
  separatorCondition: (v: unknown) => boolean;

  @ViewChild('formFieldSelect')
  formFieldSelect: MatSelect;

  open(): void {
    this.formFieldSelect.open();
  }

  constructor() {
    super();
    this.resetValue = -1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (this.multiple && this.clearable && !Array.isArray(this.resetValue)) {
      this.resetValue = [];
    }
  }

  getOptionId(option: unknown, index: number): string {
    if (option && typeof option === 'object' && 'description' in option) {
      return `${this.field}-option-${(option as { description: string }).description}`;
    }
    const value = this.valueFn ? this.valueFn(option) : option;
    if (typeof value === 'string' || typeof value === 'number') {
      return `${this.field}-option-${value}`;
    }
    return `${this.field}-option-${index}`;
  }

  getOptionValue(option: unknown): unknown {
    if (this.valueFn) {
      return this.valueFn(option);
    }
    return option;
  }
}
